import React from 'react';
import Select from 'react-select';

const LocationSelect = ({ 
  options, 
  value, 
  onChange, 
  placeholder, 
  isDisabled = false,
  name,
  id 
}) => {
  // Custom styles to match your design
  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      height: '40px',
      minHeight: '40px',
      border: state.isFocused 
        ? '2px solid #E67E42' 
        : '1px solid #e0e0e0',
      borderRadius: '6px',
      boxShadow: state.isFocused 
        ? '0 0 0 3px rgba(230, 126, 66, 0.1)' 
        : 'none',
      '&:hover': {
        border: state.isFocused 
          ? '2px solid #E67E42' 
          : '1px solid #ccc'
      },
      backgroundColor: isDisabled ? '#f5f5f5' : 'white',
      cursor: isDisabled ? 'not-allowed' : 'pointer'
    }),
    valueContainer: (provided) => ({
      ...provided,
      height: '38px',
      padding: '0 12px'
    }),
    input: (provided) => ({
      ...provided,
      margin: '0px',
    }),
    indicatorSeparator: () => ({
      display: 'none',
    }),
    indicatorsContainer: (provided) => ({
      ...provided,
      height: '38px',
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      color: '#666',
      '&:hover': {
        color: '#333'
      }
    }),
    placeholder: (provided) => ({
      ...provided,
      color: '#999',
      fontSize: '14px'
    }),
    singleValue: (provided) => ({
      ...provided,
      color: '#333',
      fontSize: '14px'
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 999999,
      backgroundColor: 'white',
      border: '1px solid #E67E42',
      borderRadius: '6px',
      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
      marginTop: '1px'
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: '200px',
      padding: '0'
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected 
        ? '#E67E42' 
        : state.isFocused 
          ? '#f8f9fa' 
          : 'white',
      color: state.isSelected ? 'white' : '#333',
      padding: '8px 12px',
      fontSize: '14px',
      cursor: 'pointer',
      '&:hover': {
        backgroundColor: state.isSelected ? '#d16a2e' : '#f8f9fa'
      }
    }),
    noOptionsMessage: (provided) => ({
      ...provided,
      color: '#666',
      fontSize: '14px',
      padding: '8px 12px'
    }),
    loadingMessage: (provided) => ({
      ...provided,
      color: '#666',
      fontSize: '14px',
      padding: '8px 12px'
    })
  };

  // Format the value for react-select
  const selectedValue = value ? options.find(option => option.value === value) : null;

  const handleChange = (selectedOption) => {
    onChange(selectedOption ? selectedOption.value : '');
  };

  return (
    <Select
      id={id}
      name={name}
      value={selectedValue}
      onChange={handleChange}
      options={options}
      placeholder={placeholder}
      isDisabled={isDisabled}
      styles={customStyles}
      isSearchable={true}
      isClearable={false}
      menuPosition="absolute"
      menuPlacement="auto"
      menuPortalTarget={document.body}
      classNamePrefix="location-select"
      noOptionsMessage={() => "No options available"}
      loadingMessage={() => "Loading..."}
    />
  );
};

export default LocationSelect;